<script setup lang="ts">
import { computed } from 'vue';
import type { FieldSchema } from '../../../types';

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    error?: string | boolean;
    field?: FieldSchema;
    isInlineEditing?: boolean;
    placeholder?: string;
    required?: boolean;
  }>(),
  {
    isInlineEditing: false,
    placeholder: 'components.forms.placeholder.common',
  }
);

const model = defineModel<string | undefined>();

const settings = computed(() => props?.field?.settings);
const _disabled = computed(() => {
  if (props.field?.state?.disabled) return props.field?.state.disabled;

  return settings.value?.editable ? !settings.value?.editable : props.disabled;
});
</script>

<template>
  <InputText
    v-model="model"
    type="text"
    :class="['h-9 w-full text-sm', { 'af-field-error': !!error }]"
    :disabled="_disabled"
    :invalid="!!error"
    :placeholder="$t(settings?.placeholder || placeholder || $t('cart.label.checkNumber'))"
    :required="settings?.required || required"
  />
</template>
